<template>
    <div id="app">
        <v-app id="inspire">
            <altaciklama></altaciklama>
            <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp>
            <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                    {{$t('Main-Company')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <sozlesmedialog ref="sozlesmedialog"></sozlesmedialog>

            <navi v-model="drawer"></navi>

            <div v-if="giris">
                <v-content>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 pb-2 sm12 md12>
                                <v-layout row wrap class=" project overdue">
                                    <v-toolbar flat="" size="100px" dark color="white">
                                        <v-toolbar-title>
                                            <span class="grey--text">
                                                {{$t('Select-Main-Company')}} ({{AnaSirketlerWiev.length}})
                                            </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>

                                        <v-btn flat class="white--text" color="info" @click="urunleregit()">
                                            <v-icon>add</v-icon>
                                            {{$t('Add-New-Product')}}
                                        </v-btn>
                                    </v-toolbar>
                                </v-layout>
                            </v-flex>


                            <div v-for="item in AnaSirketlerWiev" v-bind:key="item.index">
                                <v-flex pl-1 pb-1 xs2 sm12 md4>
                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                            class="mx-auto" width="300">
                                            <v-card-title>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout justify-center>
                                                            <div>

                                                                <v-layout justify-center>
                                                                    <span
                                                                        class="font-weight- grey--text title mb-2">&nbsp;
                                                                    </span>
                                                                </v-layout>

                                                                <v-layout justify-center>
                                                                    <span class="ucnokta">{{item.text}}
                                                                    </span>
                                                                </v-layout>

                                                                <v-layout justify-center>
                                                                    <span
                                                                        class="font-weight- grey--text  mb-2">
                                                                        ({{item.baglisirketler.length}} {{ $t('Company') }} )
                                                                    </span>
                                                                </v-layout>

                                                                <v-divider></v-divider>


                                                                <v-layout justify-center>
                                                                   
                                                                    <v-btn :disabled="item.UyelikStatus==false" flat
                                                                        @click="urundetayGetir(item)" color="info">
                                                                        <v-icon>iso</v-icon> {{$t('Usage-Information')}}
                                                                    </v-btn>
                                                                </v-layout>

                                                                <v-divider></v-divider>

                                                                <v-layout justify-center>
                                                                    <div class="font-weight-light grey--text caption mb-2">
                                                                        {{$t('Membership-Termination-Date')}}
                                                                    </div>
                                                                </v-layout>

                                                                <v-layout v-if="item.UyelikStatus==true" justify-center>
                                                                    <div class="font-weight-light red--text title mb-2">
                                                                        {{item.UyelikBitis | dateformat}}
                                                                    </div>
                                                                    <div class="font-weight-light red--text title mb-2">
                                                                        &nbsp;</div>
                                                                </v-layout>
                                                                <v-layout v-if="item.UyelikStatus==false"
                                                                    justify-center>
                                                                    <div class="font-weight-light red--text title mb-2">
                                                                        &nbsp;</div>
                                                                    <div class="font-weight-light red--text title mb-2">
                                                                        {{ $t('You-not-have-active-membership') }}
                                                                    </div>
                                                                </v-layout>

                                                                <v-divider></v-divider>

                                                            </div>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 ma-1 md12>

                                                        <v-layout justify-start>

                                                            <v-flex xs2 sm2 md3>
                                                                <v-btn class="white--text" icon color="white">
                                                                    <v-icon color="grey">settings</v-icon>
                                                                </v-btn>
                                                            </v-flex>

                                                            <v-divider vertical></v-divider>

                                                            <v-flex v-if="item.active==true" xs8 ma-1 sm8 md8>
                                                                <v-layout justify-center>
                                                                    <v-btn block class="white--text"
                                                                        data-test="sirket-giris" :data-test-sirket="item.text"
                                                                        @click="sysLogin(item.userid,item.musteriid,item.id,item.baglisirketler,item.UlkeID,item.parabirimi,item.baglisirketlercoper,item.baglisirketlermuhasebe,item.UyelikBitis,item.KalanKontor,item.AktifUyelikPaketID)"
                                                                        color="info">
                                                                        {{$t('Login')}}
                                                                    </v-btn>
                                                                </v-layout>
                                                            </v-flex>
                                                            <!-- item.uyelikBitis,item.KalanKontor -->
                                                            <v-flex xs8 ma-1 v-if="item.active==false" sm8 md8>
                                                                <v-layout justify-center>
                                                                    <v-btn block class="white--text"
                                                                        @click="seciliurunleregit(item)" color="red">
                                                                        {{ $t('Purchase-Membership') }}
                                                                    </v-btn>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>

                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </div>
                          
                        </v-layout>
                    </v-container>
                </v-content>
            </div>

            <div v-if="Urunler">
                <v-content>
                    <v-container fluid>
                        <div v-if="urunekrani">
                            <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-start>
                                        <span class=" grey--text headline"> {{ $t('Add-Renew-New-Product') }} </span>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-end>
                                        <v-btn @click="sirketleredon()" flat class="white--text" color="red">
                                            <v-icon>arrow_back_ios</v-icon> {{ $t('Return-v2') }} 
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-flex xs6 sm6 md6>
                                <v-radio-group v-model="sirkettipi" row>
                                    <v-radio label="Mevcut Şirket" value="0"></v-radio>
                                    <v-radio :label="$t('New-Company')" value="1"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-select v-if="mevcutsirketmi" item-value="id" item-text="text"
                                    :label="$t('Select-Your-Main-Company')" autofocus persistent-hint :items="AnaSirketler"
                                    v-model="AnaSirket" bottom></v-select>
                            </v-flex>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md6>
                                    <v-layout justify-start>
                                        <span class=" grey--text headline">{{ $t('Your-Active-Industry') }}</span>
                                    </v-layout>
                                </v-flex>

                            </v-layout>

                            <v-divider></v-divider>
                            <v-radio-group v-model="sektor" row>
                                <v-radio label="Turizm Acentası " value="0"></v-radio>
                            </v-radio-group>
                            <span class=" grey--text  headline">{{$t('Subscription-Type')}}</span>
                            <v-divider></v-divider>
                            <v-radio-group v-model="pakettipi" row>
                                <v-radio :label="$t('Packages') " value="1"></v-radio>
                                <v-radio label="Ek Paketler" value="2"></v-radio>
                            </v-radio-group>
                            <span v-if="urunekrani" class=" grey--text  headline"> {{ $t('Products') }} </span>
                            <v-divider></v-divider>
                        </div>

                        <v-layout row wrap v-if="urunekrani">
                            <div v-for="item in productshow" v-bind:key="item.index">
                                <v-flex ma-2 xs12 sm4 md3>
                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                            class="mx-auto" width="300">

                                            <v-flex xs12 sm12 md12>
                                                <v-card flat color="light-blue darken-4">
                                                    <v-layout pt-3 pb-3 justify-center>
                                                        <span
                                                            class="display-1 font-weight-  white--text">{{item.PaketAdi}}
                                                        </span>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>

                                            <v-card-title>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout row wrap justify-center>

                                                            <v-flex xs12 sm12 md12>
                                                                <v-layout pt-1 align-center="" justify-center>
                                                                    <div
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>flight</v-icon> {{item.BiletAdet}}
                                                                        {{ $t('Ticket') }}
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>hotel</v-icon> {{item.CoperAdet}}
                                                                        Coper
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>monetization_on</v-icon>
                                                                        {{item.CariAdet}} Cari
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <v-btn flat @click="urundetayGetir(item)"
                                                                        color="info"> {{$t('Further-Information')}}</v-btn>
                                                                </v-layout>
                                                                <v-divider></v-divider>
                                                                <v-layout justify-center>
                                                                    <span class="headline  font-weight-light red--text">
                                                                        {{item.Fiyat | moneyformat}} {{ this.getparabirimi() }}  
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 ma-1 md12>
                                                        <v-btn block @click="Odeme(item)" class="white--text"
                                                            color="green">
                                                            <v-icon small color="white"> shopping_cart</v-icon> &nbsp;
                                                            {{$t('Buy')}}
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>

                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </div>

                            <v-flex ma-2 xs2 sm1 md1>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                        class="mx-auto" width="300">


                                        <v-flex xs12 sm12 md12>

                                            <v-card flat color="red">
                                                <v-layout pt-3 pb-3 justify-center>
                                                    <span class="display-1 font-weight-  white--text">{{$t('Special')}}
                                                    </span>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>
                                        <v-card-title>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center>
                                                        <div>

                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s2')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s3')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s4')}}</div>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <span
                                                                    class="display-1  font-weight-light red--text">&nbsp;</span>
                                                            </v-layout>
                                                        </div>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 ma-1 md12>
                                                    <v-btn block class="white--text" color="green">
                                                        <v-icon small color="white">call</v-icon> &nbsp; +90 850 811 12
                                                        84
                                                    </v-btn>
                                                </v-flex>

                                            </v-layout>
                                        </v-card-title>

                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>


                        <v-layout v-if="odemeekrani" row wrap>

                            <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-start>
                                        <span class="headline">{{ $t('Choose-Payment-Method') }}</span>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-end>
                                        <v-btn @click="urunleredon()" flat class="white--text" color="red">
                                            <v-icon>arrow_back_ios</v-icon> {{ $t('Return-Product-Choosing-Page') }}
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>


                            <v-flex xs12 sm12 md12>
                                <v-divider></v-divider>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <span class="headline"></span>
                                <v-radio-group v-model="UrunKayit.OdemeTip" row>
                                    <v-radio :label="$t('Transfer-v3')" value="0"></v-radio>
                                    <v-radio :label="$t('Credit-Card')" value="1"></v-radio>
                                </v-radio-group>
                            </v-flex>


                            <v-flex ma-2 xs12 sm12 md5>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-flex xs12 ma-2 v-if="kredikarti" sm6 md6>
                                                <v-layout justify-start>
                                                    <v-icon color="pink">credit_card</v-icon> &nbsp; <span
                                                        class="title pink--text font-weight-regular">
                                                        {{ $t('Credit-Card-Details') }}
                                                    </span>
                                                </v-layout>
                                                <v-divider></v-divider>

                                                <v-form ref="formodeme" v-model="validOdeme" lazy-validation>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-text-field hide-details=""
                                                                :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                                                v-model="PaymentForm.CardNumber" :label="$t('Credit-Card-No')"
                                                                mask="####-####-####-####">
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>
                                                            <v-text-field hide-details=""
                                                                v-model="PaymentForm.CardHolder"
                                                                :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                                                :label="$t('Name-on-Card')">
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md6>
                                                            <v-select :items="sonkullanimAy" :label="$t('Expiry-Month')"
                                                                v-model="PaymentForm.ExpirationMonth"
                                                                :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                                                hide-details="" item-text="text" item-value="id">
                                                            </v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md6>
                                                            <v-select :items="sonkullanimYil"
                                                                v-model="PaymentForm.ExpirationYear"
                                                                :label="$t('Expiry-Year')" hide-details=""
                                                                :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                                                item-text="text" item-value="id">
                                                            </v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md4>
                                                            <v-text-field label="CVV" v-model="PaymentForm.Cvv"
                                                                :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                                                hide-details="" mask="###">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-form>
                                            </v-flex>

                                            <v-flex xs12 v-if="!kredikarti" sm6 md6>

                                                <v-flex xs12 pa-2 sm12 md12>
                                                    <v-layout justify-center="" fill-height="" align-center="">
                                                        <span class="grey--text title">{{$t('Transfer-Confirmation')}}</span>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 pa-2 sm12 md12>
                                                    <v-layout justify-center="" fill-height="" align-center="">
                                                        <span class="grey--text body-2"> *{{$t('Transfer-Confirmation-Confirm')}}
                                                            <span class="red--text font-weight-bold body-2">
                                                                ''{{havaleKodu}} '' </span>{{$t('Transfer-Confirmation-Confirm-s2')}}</span>
                                                    </v-layout>
                                                </v-flex>

                                            </v-flex>

                                            <v-flex xs12 sm6 ma-2 md6>
                                                <v-card flat class="white--text">
                                                    <v-card flat="">
                                                        <v-card-actions>
                                                            <v-layout align-end="" row wrap>

                                                                <v-flex xs12 sm6 ma-2 md12>
                                                                    <v-layout justify-center>
                                                                        <div>
                                                                            <v-layout justify-center>
                                                                                <div class="font-weight-light grey--text title mb-2">
                                                                                    &nbsp;
                                                                                </div>
                                                                            </v-layout>
                                                                            <v-layout justify-center>
                                                                                <span class="display-1 font-weight-bold  grey--text">
                                                                                    {{ $t('totalamount') }}
                                                                                </span>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>
                                                                            <v-layout pa-2 justify-center>
                                                                                <div
                                                                                    class="font-weight-regular red--text display-1 mb-2">
                                                                                    {{toplamtutar | moneyformat}} {{ this.getparabirimi() }}
                                                                                </div>
                                                                            </v-layout>
                                                                            <v-layout justify-center>
                                                                                <div
                                                                                    class="font-weight-light grey--text title mb-2">
                                                                                </div>
                                                                            </v-layout>
                                                                            <v-layout justify-center>
                                                                                <v-btn v-if="!kredikarti" block
                                                                                    class="white--text"
                                                                                    @click="SatinAl()" color="green">
                                                                                    
                                                                                    {{ $t('Confirm-Transfer') }}
                                                                                    </v-btn>
                                                                                <v-btn v-if="kredikarti" block
                                                                                    class="white--text"
                                                                                    @click="KrediOdemeYap()"
                                                                                    color="green">
                                                                                    {{$t('Make-Payment')}} &nbsp;<v-icon>3d_rotation
                                                                                    </v-icon>
                                                                                </v-btn>
                                                                            </v-layout>

                                                                        </div>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-card>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex ma-2 v-if="kredikarti" xs12 sm12 md6>
                                <v-card flat="">
                                    <v-layout row wrap>

                                        <v-flex xs1 sm1 mt-2 md1>
                                            <v-layout justify-start="" align-center fill-height="">

                                                <img :src="cardimageLink" height="50px;" width="50px;">
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs10 mt-2 ml-2 sm10 md10>
                                            <v-layout justify-start fill-height="" align-center="">
                                                <span class=" black--text subheading"> {{binResult.KartBanka}} &nbsp;
                                                    {{$t('Instalment-Rates')}}</span> &nbsp;&nbsp;
                                                <span class=" red--text caption"> ***
                                                     {{ $t('Instalment-details-will-card-details') }}
                                                </span>
                                            </v-layout>

                                        </v-flex>


                                        <v-flex xs12 sm12 md12>
                                            <v-layout justify-start>
                                                <v-divider></v-divider>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 pl-2 pt-2 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs3 sm3 md3>
                                                            <div pl-4 class="font-weight-bold grey--text subheading ">
                                                                {{ $t('Instalment-Amount-v2') }}
                                                            </div>
                                                        </v-flex>
                                                        <v-flex xs3 sm3 md3>
                                                            <div class="font-weight-bold grey--text subheading ">
                                                                {{$t('Instalment-Amount')}}
                                                            </div>
                                                        </v-flex>
                                                        <v-flex xs3 sm3 md3>
                                                            <div class="font-weight-bold grey--text subheading ">
                                                                  {{$t('totalamount')}}
                                                            </div>
                                                        </v-flex>

                                                    </v-layout>


                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-start>
                                                        <v-divider></v-divider>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs3 sm3 md3>
                                                    <v-radio-group hide-details="" v-model="secilentaksit"
                                                        :mandatory="false">
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout pl-4 row wrap="">
                                                                <v-flex v-for="item in seciliozelOran"
                                                                    v-bind:key="item.id" xs12 pa-2 sm12 md12>
                                                                    <v-radio :label="item.TaksitLabel"
                                                                        v-bind:value="item">
                                                                    </v-radio>
                                                                </v-flex>

                                                            </v-layout>
                                                        </v-flex>
                                                    </v-radio-group>
                                                </v-flex>


                                                <v-flex xs9 sm9 pt-4 md9>
                                                    <v-flex xs12 v-for="item in seciliozelOran" v-bind:key="item.id"
                                                        sm12 md12>
                                                        <v-layout row wrap="">
                                                            <v-flex xs12 pa-2 sm6 md4>
                                                                <div class="font-weight- grey--text subheading ">
                                                                    {{item.TaksitTutar | moneyformat}}
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 pa-2 sm6 md4>
                                                                <div class="font-weight- grey--text subheading ">
                                                                    {{item.ToplamTutar | moneyformat}}
                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>
                                </v-card>
                            </v-flex>

                        </v-layout>



                    </v-container>
                </v-content>
            </div>




            <v-dialog v-model="dialogyenisirket" persistent max-width="400px">
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">


                            <v-toolbar-title>{{ $t('New-Parent-Company') }}</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex pa-1 xs12 sm12 md12>

                        <v-layout wrap>
                            <div class="flex md12">
                                <v-text-field :label="$t('Company-Title')" v-model="yenisirketunvani"></v-text-field>
                            </div>
                        </v-layout>

                    </v-flex>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" v-if="!bekle" flat @click="sirketaciptal()">{{$t('Cancel')}}</v-btn>
                        <v-btn color="info" v-if="!bekle" flat @click="yenisirketac()">{{$t("save_button")}}</v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogurunDetay" scrollable="" max-width="400px">
                <v-card flat color="grey lighten-5">
                    <v-card-title> <span class=" grey--text font-weight- subheading">
                            {{$t('Remaining-Monthly-Amount-of-Usage')}} </span></v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                        <v-layout row wrap>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-list>
                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column align-center>
                                                                                <span class="font-weight-bold"> {{$t('Number-and-Type')}}</span> </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>



                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justiy-start align-center>
                                                                                <span class="font-weight-bold"> {{$t('Number')}}
                                                                                </span>
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Tickets')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.BiletKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Void')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.VoidKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Refunds')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.IadeKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Coper-PNRs')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.CoperKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Coper-PNRs-Cancelled')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.CoperIptalKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Visas')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.VizeKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Current-Number')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.CariKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Free-Invoicing')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.FaturaKontor}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>
                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Nombre-de-crédits-additionels')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{urunDetay.EkKontorSayisi}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>



                                    </v-list>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <span class=" red--text font-weight- caption"> &nbsp; {{$t('package-limits-need-to-buy')}}
                                     </span>
                            </v-layout>
                        </v-layout>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="dialogurunDetay=false">{{$t('Close')}}</v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>

        </v-app>
    </div>

</template>

<script>
    import auth from '../../../api/auth'
    import _ from 'underscore'
    import router from '../../../router'
    import helpers from "@/components/app/customcomp/helpers.js"
    import navi from "@/components/app/account/navigator.vue"
    import $ from '@/plugins/i18n.js'
    import {
        Trans
    } from '@/plugins/Translation'
    import sozlesmedialog from "@/components/app/customcomp/sozlesmedialog.vue"
    import altaciklama from "@/components/app/account/altaciklama.vue"
    import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"


    export default {
     data() {
        return {
           
            loadingmesaj: this.$t('Parent-company-listing'),
            loadingdialog: false,
            urunDetay: {
                BiletKontor: 0,
                CariKontor: 0,
                CoperIptalKontor: 0,
                CoperKontor: 0,
                FaturaKontor: 0,
                IadeKontor: 0,
                VizeKontor: 0,
                VoidKontor: 0,
                EkKontorSayisi: 0
            },
            dialogurunDetay: false,
            havaleKodu: null,
            ozelOranlar: [],
            seciliozelOran: null,
            cardimageLink: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
            cardimageLinkyedek: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
            secilentaksit: null,
            musteriidurun: null,
            pass: null,
            yedekresponse: [],
            bekle: false,
            AnaSirketlerWiev: [],
            AnaSirketler: [],
            Sirketler: [],
            AnaSirket: {},
            Sirket: {},
            giris: true,
            Urunler: false,
            urunlerlist: [],
            active: false,
            sektor: '0',
            pakettipi: '1',
            productshow: [],
            odemetipi: false,
            havale: true,
            kredikarti: false,
            odemeekrani: false,
            toplamtutar: 0,
            urunekrani: true,
            musteriid: null,
            dialogyenisirket: false,
            yenisirketunvani: null,
            sirkettipi: '0',
            karttipi: [{
                    id: 'M',
                    text: 'Master Card'
                },
                {
                    id: 'VI',
                    text: 'VISA'
                },
                {
                    id: 'A',
                    text: 'American Express'
                },
            ],
            sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                '2029', '2030'
            ],
            dictionary: {
                custom: {
                    kartno: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                        min: this.$t('Card-Number-Must-16-Digits')
                    },

                    selectkarttipi: {
                        required: () => this.$t('Please-choose'),
                    },
                    kartcari: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanim: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanimyil: {
                        required: () => this.$t('Please-choose'),
                    },

                }
            },

            PaymentForm: {
                Id: null,
                CardHolder: null,
                CardNumber: null,
                Cvv: null,
                ExpirationYear: null,
                ExpirationMonth: null,
                MobilePhone: null,
                VirtualPosId: null,
                InstallmentCount: null,
                Amount: 0,
                OkUrl: 'http://next.arkman.com.tr/#/odeme/basarili',
                FailUrl: 'localhost:8080/#/odeme/hata'
            },

            itemsnavi: [{
                    icon: 'business',
                    text: this.$t('Corporate-transactions'),
                    to: 'anasirket',
                },
                {
                    icon: 'people',
                    text: this.$t('Member-Transactions'),
                    to: 'login-uye'
                },
                {
                    icon: 'people',
                    text: this.$t('Authority-Groups'),
                    to: 'login-yetkigruplist'
                }
            ],
            clipped: true,
            drawer: true,
            fixed: false,
            miniVariant: false,
            right: true,
            rightDrawer: false,
            binResult: {
                Bin: null,
                Dkk: null,
                KartBanka: null,
                KartOrg: null,
                KartTip: null,
                SanalPosId: null,
            },

            MusteriUrun: {
                ID: null,
                MusteriID: null,
                PaketBilgi: {
                    PaketID: null,
                    PaketTip: null,
                },
                OdemeBilgi: {
                    ID: null,
                    OdemeTip: 0,
                    OdemeOnay: false
                },
                BaslangicTarih: null,
                BitisTarihi: null,
                KontorAdet: 0,
                KalanKontorAdet: 0,
                BiletAdet: 0,
                FaturaAdet: 0,
                CariAdet: 0,
                IadeAdet: 0,
                VoidAdet: 0,
                CoperAdet: 0,
                CoperIptalAdet: 0,
                VizeAdet: 0,
            },

            UrunKayit: {
                ID: null,
                OdemeTip: '0', // 0 Havale 1 Kredi
                OdemeOnay: false,
                Tarih: null,
                Tutar: 0,
                Banka: null,
                TaksitAdet: null,
                VadeFarki: null,
                VadeTarihi: null,
                CariKod: null,
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: null,
                IslemID: null,
                GuID: null,
                SiparisID: null,
                DekontID: null,





                // ID: null,
                // MusteriInfo: {
                //     MusteriID: null,
                //     MusteriKod: null
                // },
                // UrunInfo: {
                //     UrunID: null
                // },
                // UrunAdet: 1,
                // BaslangicTarih: null,
                // BitisTarih: null,
                // Kontor: null,
                // KalanKontor: null,
                // SatisTarihi: null,
                // SatisTutar: 0,
                // Aktif: null,
                // OdemeOnay: 'false'
            },

            mevcutsirketmi: true,
            yenisirket: false,
            dialog: false,
            items: [{
                    icon: 'domain',
                    text: this.$t('Corporate-transactions')
                },
                {
                    icon: 'contacts',
                    text: this.$t('Member-Transactions')
                },
            ],


            faturainfo: [],
            newuserstatus: false,
            loginstatus: true,
            e1: 0,
            e2: true,
            e3: true,
            e4: true,
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('Wrong-e-mail')
                }
            },
            Kartbilgisi: null,
            YeniKullanici: {
                UserID: null,
                MusteriID: 0,
                KullaniciAdi: null,
                Email: null,
                Sifre: null,
                Tip: 0,
                AdSoyad: null,
                Deleted: false,
                Aktif: false,
                MusteriBilgi: [],
                OdemeOnay: false,
            },
            unvan: null,
            confirm: null,
            Credential: {
                email: '',
                password: ''
            },
            valid: true,
            validOdeme: true,
            errorMsg: '',
            errorAlert: false,

        }
        },
        props: {
            source: String
        },
        methods: {
             getmuhasebeSirketNo(musteriId, sirketno, sirketler) {
             if (sirketler.length>0)
            {
                if (sirketno=='undefined' || sirketno==0)
                {
                return sirketler[0].CompanyID
                }
                else{
                     try{
                     var index = sirketler.filter(function (el) {
                    return el.CompanyID == sirketno
                });
                return index[0].CompanyID
                }
                catch{
                    return '0';
                }
                }
            }
            else
            {
                 return '0';
               
            }
               
            },
            getmuhasebeSirketAdi(musteriId, sirketno, sirketler) {
             if (sirketler.length>0)
            {
                if (sirketno=='undefined' || sirketno==0)
                {
                return sirketler[0].CompanyShortName
                }
                else{
                     try{
                     var index = sirketler.filter(function (el) {
                    return el.CompanyID == sirketno
                });
                return index[0].CompanyShortName
                }
                catch{
                    return '';
                }
                }
            }
            else
            {
                 return '';
               
            }
               
            },
            getmuhasebeUnvan(musteriId, sirketno, sirketler) {
             if (sirketler.length>0)
            {
                if (sirketno=='undefined' || sirketno==0)
                {
                return sirketler[0].CompanyShortName
                }
                else{
                     try{
                     var index = sirketler.filter(function (el) {
                    return el.CompanyID == sirketno
                });
                return index[0].CompanyShortName
                }
                catch{
                    return '';
                }
                }
            }
            else
            {
                 return '';
               
            }
            },
            getcoperUnvan(musteriId, sirketno, sirketler) {
               
               
                var index = sirketler.filter(function (el) {
                    return el.SirketNo == sirketno
                });
                return index[0].SirketIsmi
            },
            getcoperSirketAdi(musteriId, sirketno, sirketler) {
                var index = sirketler.filter(function (el) {
                    return el.SirketNo == sirketno
                });
                
                return index[0].SirketKod
            },
            getcariUnvan(musteriId, sirketno, sirketler) {
              
                var index = sirketler.filter(function (el) {
                    return el.SirketKodu == sirketno
                });
                
                return index[0].SirketUnvani
                
            },
            getcariSirketAdi(musteriId, sirketno, sirketler) {
                var index = sirketler.filter(function (el) {
                    return el.SirketKodu == sirketno
                });
                return index[0].SirketAdi
                
            },
            urundetayGetir(val) {
               
                this.dialogurunDetay = true
                this.urunDetay = val.KalanKontor
            },
            KrediOdemeYap() {
                if (this.$refs.formodeme.validate()) {

                    var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
                    if (ml != null) {
                        this.PaymentForm.MobilePhone = ml.UserInfo.GSM
                    } else {
                        this.PaymentForm.MobilePhone = null
                    }

                    this.PaymentForm.VirtualPosId = this.secilentaksit.SanalPosId
                    this.PaymentForm.InstallmentCount = this.secilentaksit.TaksitAdet
                    this.PaymentForm.Amount = Math.round(this.secilentaksit.ToplamTutar * 100) / 100
                    var params = this.PaymentForm

                    this.$http.post(auth.API_URL + 'api/ParamPos/GetPayTreeD', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        if (response.body.IsSuccessfull) {

                            var url = response.body.ContinueUrl
                            window.open(url, '_self');
                        } else {
                            this.text1 = response.body.ResponseDescription
                            this.snackbar = true
                        }


                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-KartOde'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-KartOde'
                            this.snackbar = true
                        }
                    })
                }
            },
            dildegistir(a) {
                if (a == null || a == '') {
                    a = 'tr'
                }

                const lang = a
                const to = this.$router.resolve({
                    params: {
                        lang
                    }
                })
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location)
                    // this.locale = e
                })

            },
            logout() {
                auth.logout()
            },
            yenisirketac() {
                this.bekle = true;

                var response1 = JSON.parse(window.localStorage.getItem('response'));

                if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
                    var params = {
                        Mail: response1.Email,
                        CustomerInfo: {
                            Ad: this.yenisirketunvani
                        }
                    }

                    this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true

                        if (response.body.Status == true) {
                            this.text1 =
                                'Yeni ana şirket kayıt işleminiz tamamlandı ve şirketinize 10 günlük ücretsiz üyelik tanımlanmıştır.'
                            this.snackbar = true
                            this.dialogyenisirket = false;
                            this.sirkettipi = '0';
                            this.bekle = false;


                            var params = {
                                Email: response1.Email

                            }
                            this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {

                                this.giris = true
                                this.Urunler = false

                                this.bekle = false;
                                this.yedekresponse = response1
                                window.localStorage.removeItem('response')

                                var sirketlers = []
                                Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                                    var anasirket = {
                                        Ad: response.body[0].MusteriBilgi[key].Ad,
                                        GenelSirketler: response.body[0].MusteriBilgi[key]
                                            .Sirketler,
                                        MusteriId: response.body[0].MusteriBilgi[key]
                                            .MusteriID,
                                        MusteriKod: response.body[0].MusteriBilgi[key]
                                            .MusteriKod
                                    }
                                    sirketlers.push(anasirket)
                                });

                                var newresponse = {
                                    AdSoyad: this.yedekresponse.AdSoyad,
                                    Email: this.yedekresponse.Email,
                                    MusteriDbler: sirketlers,
                                    Token: this.yedekresponse.Token,
                                    UserId: this.yedekresponse.UserId
                                }
                                window.localStorage.setItem('response', JSON.stringify(newresponse));

                                this.guncelle();

                                //yeni response oluşturuldu burda kaldı

                            }, (response) => {
                                if (response.status === 0) {
                                    this.bekle = false;

                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                } else {
                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                }
                            })
                        }

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        }
                    })

                } else {
                    this.text1 = this.$t('Please-enter-corporate-title')
                    this.snackbar = true
                    this.bekle = false;

                }
            },
            sirketaciptal() {
                this.dialogyenisirket = false;
                this.sirkettipi = '0';
            },
            urunleredon() {
                this.urunekrani = true;
                this.odemeekrani = false;
            },
            sirketleredon() {
                this.Urunler = false;
                this.giris = true;
            },
            Odeme(val) {

                if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof (this.sirkettipi) !=
                    'object') {
                    this.UrunKayit.Tutar = val.Fiyat
                    this.toplamtutar = val.Fiyat;
                    this.MusteriUrun.PaketBilgi.ID = val.PaketID
                    this.odemeekrani = true;
                    this.urunekrani = false;
                    this.havaleKodu = this.defaultKod(6);

                    this.$http.post(auth.API_URL + 'api/ParamPos/GetOzelOran', null, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.ozelOranlar = response.body

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-GetOzelOran'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-GetOzelOran'
                            this.snackbar = true
                        }
                    })

                } else {
                    this.text1 = this.$t('Please-select-a-company')
                    this.snackbar = true
                }


            },
            defaultKod(length) {

                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                    const rnd = Math.floor(Math.random() * 90000) + 10000;
                    return result + rnd;
                }
            },
            SatinAl() {

                this.UrunKayit.Tarih = getDateNow()
                this.UrunKayit.OdemeOnay = false
                //  this.UrunKayit.MusteriInfo.MusteriKod = this.musteriidurun


                var params = this.UrunKayit

                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    if (response.body.Status == true) {

                        this.text1 = this.$t('Payment-successful-you-being-redirected-page')
                        this.snackbar = true

                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })
            },
            BinKodSorgula() {
                var params = this.PaymentForm

                this.$http.post(auth.API_URL + 'api/ParamPos/GetBinCode', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.binResult = response.body

                    this.seciliozelOran = []

                    this.ozelOranlar.forEach(element => {

                        if (this.binResult.SanalPosId == element.SanalPosId) {

                            this.cardimageLink = element.KrediKartiBankaGorsel


                            element.TaksitOranlar.forEach(element1 => {


                                if (element1.Oran > -1) {

                                    var Tutar = (this.toplamtutar * element1.Oran / 100) + this
                                        .toplamtutar
                                    var taksittutar = Tutar / element1.Taksit

                                    var taksitlabel = null

                                    if (element1.Taksit == 1) {
                                        taksitlabel = this.$t('Lump-Sum')
                                    } else {
                                        taksitlabel = element1.Taksit +  this.$t('Instalment')
                                    }


                                    var taksitbilgi = {
                                        TaksitLabel: taksitlabel,
                                        TaksitAdet: element1.Taksit,
                                        SanalPosId: element.SanalPosId,
                                        TaksitTutar: taksittutar,
                                        ToplamTutar: Tutar
                                    }


                                    this.seciliozelOran.push(taksitbilgi)

                                }

                            });
                            this.secilentaksit = this.seciliozelOran[0]

                        }

                    });




                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })


            },
            KartOdemesiYap() {},
            urunleregit() {

                var url = '#/account/urunler/id?sirket=null'
                window.open(url, '_self')

            },
            seciliurunleregit(val) {
console.log(val);
                var url = '#/account/urunler/id?sirket=' + val.id
                window.open(url, '_self')

            },
            sysLogin,
            getDateNow,
            guncelle,
            userlist,
            CoperWebScriptCreate,
            Yonlendir
            
        },
        filters: {

            dateformat: function (t) {
                return helpers.dateformat(t);
            },
            moneyformat: function (m) {
                return helpers.moneyformat(m);
            },

            bakiyekontrol: function (m) {
                return helpers.bakiyekontrol(m);
            }

        },
        beforeMount: beforeMount,
        components: {
            'navi': navi,
            sozlesmedialog,
            altaciklama,
            loadingcomp
        },
        watch: {

            'secilentaksit': function (value) {
                this.toplamtutar = value.ToplamTutar
            },
            'PaymentForm.CardNumber': function (value) {
                if (value.length > 5) {
                    this.BinKodSorgula();
                }

                if (value.length < 6) {
                    this.binResult.KartBanka = null
                    this.seciliozelOran = []
                    this.cardimageLink = this.cardimageLinkyedek
                    this.toplamtutar = this.UrunKayit.SatisTutar
                }
            },


            'pakettipi': function (value) {
                if (value == 1) {
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 1)
                            this.productshow.push(element)
                    });
                } else {

                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 2)
                            this.productshow.push(element)
                    });

                }
            },
            'UrunKayit.OdemeTip': function (value) {
                if (value == '0') {
                    this.havale = true;
                    this.kredikarti = false;
                } else {

                    this.havale = false;
                    this.kredikarti = true;

                }
            },
            'AnaSirket': function (value) {

                if (value != null) {
                    this.musteriidurun = value
                } 
            },
            'sirkettipi': function (value) {
                if (value == '0') {
                    this.mevcutsirketmi = true;
                    this.yenisirket = false;
                    this.dialogyenisirket = false;

                } else {
                    this.dialogyenisirket = true;
                    this.mevcutsirketmi = false;
                    this.yenisirket = true;

                }
            }



        }
    }

    function beforeMount() {
        this.loadingmesaj = this.$t('Parent-company-listing');
        this.loadingdialog = true

        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.

        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

           // this.dildegistir(response.body.UserInfo.DefaultDil);

            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))

            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

            var sirketlers = []


            for (let index = 0; index < response1.MusteriDbler.length; index++) {
                const element = response1.MusteriDbler[index];
                var sirket = {
                    text: element.Ad,
                    id: element.MusteriKod,
                    musteriid: element.MusteriId,
                    baglisirketler: element.GenelSirketler,
                    baglisirketlercoper: element.GenelSirketlerCoper,
                    baglisirketlermuhasebe : element.GenelSirketlerMuhasebe
                }
 
                sirketlers.push(sirket);
            }
            // Object.keys(response1.MusteriDbler).forEach(key => {
                
            //     var sirket = {
            //         text: response1.MusteriDbler[key].Ad,
            //         id: response1.MusteriDbler[key].MusteriKod,
            //         musteriid: response1.MusteriDbler[key].MusteriId,
            //         baglisirketler: response1.MusteriDbler[key].GenelSirketler,
            //         baglisirketlercoper: response1.MusteriDbler[key].GenelSirketlerCoper,
            //         baglisirketlermuhasebe : response1.MusteriDBler[key].GenelSirketlerMuhasebe
            //     }
 
            //     sirketlers.push(sirket)
            // });

            this.AnaSirketler = sirketlers;
            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;
                }).indexOf(element.id);

                var id = element.id;
                var anasirketUlkeID = response2.AnaSirketInfo[aktifmi].UlkeID;
                var defaultParaBirimi = response2.AnaSirketInfo[aktifmi].UlkeInfo.ParaBirimi;
                var musteriid = element.musteriid;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler
                var baglisirketcoper = element.baglisirketlercoper
                var baglisirketmuhasebe = element.baglisirketlermuhasebe

                var params = {
                    MusteriID: element.musteriid
                }

                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
console.log(response);
                    if (response.body.UyelikStatus != true) {
                        active = false
                        window.localStorage.setItem('active','0');
                    } else {
                        active = true
                        window.localStorage.setItem('active','1');
                    }
                  
                    var sirket = {
                        userid: response1.UserId,
                        musteriid: musteriid,
                        id: id,
                        parabirimi: defaultParaBirimi,
                        text: text,
                        UyelikBitis: response.body.UyelikBitisTarihi,
                        KalanKontor: response.body.KontorSayilari,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        baglisirketlercoper: baglisirketcoper,
                        baglisirketlermuhasebe:baglisirketmuhasebe,
                        active: active,
                        UlkeID: anasirketUlkeID,
                        AktifUyelikPaketID:response.body.AktifUyelikPaketID
                    }
                    yedeklist.push(sirket)

                    this.AnaSirketlerWiev = yedeklist

                    this.AnaSirketlerWiev.sort((a, b) => (a.text.toLocaleUpperCase('tr') > b
                        .text.toLocaleUpperCase('tr')) ? 1 : ((b.text.toLocaleUpperCase(
                        'tr') > a.text.toLocaleUpperCase('tr')) ? -1 : 0));
                    this.loadingdialog = false

                }, (response) => {
                    this.loadingdialog = false
                    if (response.status === 0) {

                        this.text1 = 'Service Unavailable-PackageCustomerInfos'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-PackageCustomerInfos'
                        this.snackbar = true
                    }
                })

            });






        }, (response) => {
            this.loadingdialog = false
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function guncelle() {

        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.

        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
          
            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));


            var sirketlers = []

            Object.keys(response1.MusteriDbler).forEach(key => {

                var sirket = {
                    text: response1.MusteriDbler[key].Ad,
                    id: response1.MusteriDbler[key].MusteriKod,
                    baglisirketler: response1.MusteriDbler[key].GenelSirketler
                }
                sirketlers.push(sirket)
            });

            this.AnaSirketler = sirketlers;
            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;


                }).indexOf(element.id);
                var id = element.id;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler

                var params = {
                    MusteriInfo: {
                        MusteriKod: element.id
                    }
                }
                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if (response.body.UyelikStatus != true) {
                        active = false
                        window.localStorage.setItem('active','0');
                    }else{
                        window.localStorage.setItem('active','1');
                    }

                    var sirket = {
                        id: id,
                        text: text,
                        UyelikBitis: response.body.UyelikBitis,
                        UyelikTip: response.body.UyelikTip,
                        KalanKontor: response.body.KalanKontor,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        active: active
                    }
                   
                    yedeklist.push(sirket)
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    }
                })
            });

            this.AnaSirketlerWiev = yedeklist


        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }

    function userlist() {

        var response = JSON.parse(window.localStorage.getItem('response'));

        var userparams = {
            Email: response.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            }
        })

    }

    function CoperWebScriptCreate(credentials)
    {
          this.$http.post(auth.API_URL + 'api/Coper/CoperDBMigration', {}, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader(),
                    'CariSirketNo': credentials.SirketKodu.toString(),
                    'CoperSirketNo': credentials.CoperSirketNo.toString(),
                    'MusteriKodu': credentials.AnaSirketKodu.toString()
                }
            })
    }

    function sysLogin2(userId, musteriId, anasirketid, sirketler, ulkeid, parabirimi, sirketlercoper,sirketlermuhasebe,uyelikBitis,urunDetayi,AktifUyelikPaketID) {
        this.loadingmesaj = "Giriş ve ayar"
        this.loadingdialog = true

        var wuml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

         window.localStorage.setItem('AktifUyelikPaketID',AktifUyelikPaketID);
         window.localStorage.setItem('UlkeID',ulkeid);

         window.localStorage.setItem('uyelikBitisi',uyelikBitis);
         const parsed=JSON.stringify(urunDetayi);
         window.localStorage.setItem('kontorBilgileri',parsed);

        var varmi = wuml.UserInfo.DefaultSirketList.filter(function (el) {
            return el.MusteriID == musteriId
        });

        var defaultsirketler = {
            DefaultCariSirket: null,
            DefaultCariSirketUnvan: null,
            DefaultCariSirketAdi: null,
            DefaultCoperSirket: null,
            DefaultCoperSirketUnvan: null,
            DefaultCoperSirketAdi: null,
            DefaultMuhasebeSirketNo: null,
            DefaultMuhasebeSirketUnvan: null,
            DefaultMuhasebeSirketAdi: null,
        }

        //cari default sirket tespit
        if (varmi.length == 1) {
            if (varmi[0].DefaultCariSirket != null) {
                defaultsirketler.DefaultCariSirket = varmi[0].DefaultCariSirket
                defaultsirketler.DefaultCariSirketUnvan = this.getcariUnvan(musteriId, varmi[0].DefaultCariSirket,
                    sirketler)
                defaultsirketler.DefaultCariSirketAdi = this.getcariSirketAdi(musteriId, varmi[0].DefaultCariSirket,
                    sirketler)


            } else {

                if (sirketler.length != 0) {
                    defaultsirketler.DefaultCariSirket = sirketler[0].SirketKodu
                    defaultsirketler.DefaultCariSirketUnvan = sirketler[0].SirketUnvani
                    defaultsirketler.DefaultCariSirketAdi = sirketler[0].SirketAdi
                } else {
                    defaultsirketler.DefaultCariSirket = 0
                    defaultsirketler.DefaultCariSirketUnvan = null
                    defaultsirketler.DefaultCariSirketAdi = null
                }

            }
        } else {

            if (sirketler.length != 0) {
                defaultsirketler.DefaultCariSirket = sirketler[0].SirketKodu
                defaultsirketler.DefaultCariSirketUnvan = sirketler[0].SirketUnvani
                defaultsirketler.DefaultCariSirketAdi = sirketler[0].SirketAdi
            } else {
                defaultsirketler.DefaultCariSirket = 0
                defaultsirketler.DefaultCariSirketUnvan = null
                defaultsirketler.DefaultCariSirketAdi = null
            }
        }




        //coper default sirket tespit
        if (varmi.length == 1) {
            if (varmi[0].DefaultCoperSirket != null) {
            
                defaultsirketler.DefaultCoperSirket = varmi[0].DefaultCoperSirket
                defaultsirketler.DefaultCoperSirketUnvan = this.getcoperUnvan(musteriId, varmi[0].DefaultCoperSirket,
                    sirketlercoper)
                defaultsirketler.DefaultCoperSirketAdi = this.getcoperSirketAdi(musteriId, varmi[0].DefaultCoperSirket,
                    sirketlercoper)


            } else {

                if (sirketlercoper.length != 0) {
                    defaultsirketler.DefaultCoperSirket = sirketlercoper[0].SirketNo
                    defaultsirketler.DefaultCoperSirketUnvan = sirketlercoper[0].SirketIsmi
                    defaultsirketler.DefaultCoperSirketAdi = sirketlercoper[0].SirketKod
                } else {
                    defaultsirketler.DefaultCoperSirket = 0
                    defaultsirketler.DefaultCoperSirketUnvan = null
                    defaultsirketler.DefaultCoperSirketAdi = null
                }
            }
        } else {

            if (sirketlercoper.length != 0) {
                defaultsirketler.DefaultCoperSirket = sirketlercoper[0].SirketNo
                defaultsirketler.DefaultCoperSirketUnvan = sirketlercoper[0].SirketIsmi
                defaultsirketler.DefaultCoperSirketAdi = sirketlercoper[0].SirketKod
            } else {
                defaultsirketler.DefaultCoperSirket = 0
                defaultsirketler.DefaultCoperSirketUnvan = null
                defaultsirketler.DefaultCoperSirketAdi = null
            }
        }
        
        //muhasebe default sirket tespit
         if (varmi.length == 1) {
            if (varmi[0].DefaultMuhasebeSirketNo != null) {
               
                defaultsirketler.DefaultMuhasebeSirketNo = varmi[0].DefaultMuhasebeSirketNo
                defaultsirketler.DefaultMuhasebeSirketUnvan = this.getmuhasebeUnvan(musteriId, varmi[0].DefaultMuhasebeSirket,
                    sirketlermuhasebe)
                defaultsirketler.DefaultMuhasebeSirketAdi = this.getmuhasebeSirketAdi(musteriId, varmi[0].DefaultMuhasebeSirket,
                    sirketlermuhasebe)

            } else {
                if (sirketlermuhasebe.length != 0) {
                    defaultsirketler.DefaultMuhasebeSirketNo = sirketlermuhasebe[0].CompanyID
                    defaultsirketler.DefaultMuhasebeSirketUnvan = sirketlermuhasebe[0].CompanyLongName
                    defaultsirketler.DefaultMuhasebeSirketAdi = sirketlermuhasebe[0].CompanyShortName
                } else {
                    defaultsirketler.DefaultMuhasebeSirketNo = 0
                    defaultsirketler.DefaultMuhasebeSirketUnvan = null
                    defaultsirketler.DefaultMuhasebeSirketAdi = null
                }
            }
        } else {
            if (sirketlermuhasebe.length != 0) {
                defaultsirketler.DefaultMuhasebeSirketNo = sirketlermuhasebe[0].CompanyID
                defaultsirketler.DefaultMuhasebeSirketUnvan = sirketlermuhasebe[0].CompanyLongName
                defaultsirketler.DefaultMuhasebeSirketAdi = sirketlermuhasebe[0].CompanyShortName
            } else {
                defaultsirketler.DefaultMuhasebeSirketNo = 0
                defaultsirketler.DefaultMuhasebeSirketUnvan = null
                defaultsirketler.DefaultMuhasebeSirketAdi = null
            }
        }

        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

        if (sirketler.length > 0) {

            var response = JSON.parse(window.localStorage.getItem('response'));

            var earsiv = 0
            var efatura = 0

            this.Sirket.id = defaultsirketler.DefaultCariSirket
            this.Sirket.text = defaultsirketler.DefaultCariSirketAdi
            this.Sirket.unvan = defaultsirketler.DefaultCariSirketUnvan

            var credentials = {
                AnaSirketKodu: anasirketid,
                UlkeID: ulkeid,
                MusteriID: musteriId,
                ParaBirimi: parabirimi,
                UserID: userId,
                SirketKodu: this.Sirket.id,
                SirketAdi: this.Sirket.text,
                SirketUnvani: this.Sirket.unvan,
                Sirketler: sirketler,
                EArsiv:  1,
                EFatura: 1,
                // EArsiv:  earsiv,
                // EFatura: efatura,
                CoperSirketNo: defaultsirketler.DefaultCoperSirket,
                CoperSirketAdi: defaultsirketler.DefaultCoperSirketAdi,
                CoperSirketUnvan: defaultsirketler.DefaultCoperSirketUnvan,
                CoperSirketler: sirketlercoper,
                MuhasebeSirketNo: defaultsirketler.DefaultMuhasebeSirketNo,
                MuhasebeSirketUnvan: defaultsirketler.DefaultMuhasebeSirketUnvan,
                MuhasebeSirketAdi: defaultsirketler.DefaultMuhasebeSirketAdi,
                MuhasebeSirketler: sirketlermuhasebe
            }

            if (credentials1 != null && credentials1.AnaSirketKodu == anasirketid) {

                credentials.CoperSirketAdi = credentials1.CoperSirketAdi
                credentials.CoperSirketNo = credentials1.CoperSirketNo
                credentials.CoperSirketUnvan = credentials1.CoperSirketUnvan
                credentials.CoperSirketler = credentials1.CoperSirketler

                credentials.SirketKodu = credentials1.SirketKodu
                credentials.SirketAdi = credentials1.SirketAdi
                credentials.SirketUnvani = credentials1.SirketUnvani
                credentials.Sirketler = credentials1.Sirketler

                credentials.MuhasebeSirketNo = credentials1.MuhasebeSirketNo
                credentials.MuhasebeSirketAdi = credentials1.MuhasebeSirketAdi
                credentials.MuhasebeSirketUnvani = credentials1.MuhasebeSirketUnvani
                credentials.MuhasebeSirketler = credentials1.MuhasebeSirketler
            }



            window.localStorage.setItem('credentials', JSON.stringify(credentials));

            var params = {
                MusteriID: credentials.MusteriID
            }

            var response = JSON.parse(window.localStorage.getItem('response'));

            var credential = {
                Email: response.Email,
                Password: this.pass,
                ActiveMusteriKod: anasirketid
            }

            // kullancının onaylaması gereken bir sözleşme varmı
            var paramssozlesme = {
                SozlesmeTip: 0,
                UserID: credentials.UserID,
                UlkeID: ulkeid,
                DilKodu: helpers.getaktifdil(),

            }

            this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractInfo', paramssozlesme, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader(),
                    'CariSirketNo': credentials.SirketKodu.toString(),
                    'CoperSirketNo': credentials.CoperSirketNo.toString(),
                    'MusteriKodu': credentials.AnaSirketKodu.toString()
                }
            }).then((response) => {
                //    this.loadingdialog = false

                if (response.body.SozlesmeExist == false) {
                    auth.logingiris(this, credential, this.$route.query.redirect)
                } else {
                    this.$refs.sozlesmedialog.open(response.body, 1).then(sonuc => {
                        if (sonuc == true) {
                                auth.logingiris(this, credential, this.$route.query.redirect)
                        } else {
                            this.text1 = this.$t('You-have-contract-approve')
                            this.snackbar = true
                        }
                    });
                }

            }, (response) => {
                   auth.logingiris(this, credential, this.$route.query.redirect)
                // this.loadingdialog = false
            })

            this.CoperWebScriptCreate(credentials);

            this.$http.post(auth.API_URL + 'api/Register/WebScriptCreate', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader(),
                    'CariSirketNo': credentials.SirketKodu.toString(),
                    'CoperSirketNo': credentials.CoperSirketNo.toString(),
                    'MusteriKodu': credentials.AnaSirketKodu.toString()
                }
            }).then((response) => {

            }, (response) => {
                if (response.status === 0) {

                    console.log('web script hatasi')
                    console.log( 'Authorization' + 'Bearer ' + auth.getAuthHeader())
                    console.log(  'CariSirketNo' + credentials.SirketKodu.toString())
                    console.log(  'CoperSirketNo' + credentials.CoperSirketNo.toString())
                    console.log(  'MusteriKodu' + credentials.AnaSirketKodu.toString())
                   
                    this.text1 = 'Service Unavailable-WebScriptCreate'
                    this.snackbar = true
                } else {
                    console.log('web script hatasi')
                    console.log( 'Authorization' + 'Bearer ' + auth.getAuthHeader())
                    console.log(  'CariSirketNo' + credentials.SirketKodu.toString())
                    console.log(  'CoperSirketNo' + credentials.CoperSirketNo.toString())
                    console.log(  'MusteriKodu' + credentials.AnaSirketKodu.toString())
                   
                    this.text1 = 'Service Unavailable-WebScriptCreate'
                    this.snackbar = true
                }
            })
            
            

        } else {
            this.text1 = this.$t('No-sub-company-for-parent-company')
            this.snackbar = true
            this.loadingdialog = false
            auth.logout()
        }



    }
async function sysLogin(userId, musteriId, anasirketid, sirketler, ulkeid, parabirimi, sirketlercoper, sirketlermuhasebe, uyelikBitis, urunDetayi, AktifUyelikPaketID) {
  this.loadingmesaj = "Giriş ve ayar"
  this.loadingdialog = true

  const wuml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

  window.localStorage.setItem('AktifUyelikPaketID', AktifUyelikPaketID);
  window.localStorage.setItem('UlkeID', ulkeid);
  window.localStorage.setItem('uyelikBitisi', uyelikBitis);
  window.localStorage.setItem('kontorBilgileri', JSON.stringify(urunDetayi));

  const varmi = wuml.UserInfo.DefaultSirketList.filter(el => el.MusteriID == musteriId);

  const defaultsirketler = {
    DefaultCariSirket: null,
    DefaultCariSirketUnvan: null,
    DefaultCariSirketAdi: null,
    DefaultCoperSirket: null,
    DefaultCoperSirketUnvan: null,
    DefaultCoperSirketAdi: null,
    DefaultMuhasebeSirketNo: null,
    DefaultMuhasebeSirketUnvan: null,
    DefaultMuhasebeSirketAdi: null,
  };

  const getFirstOrDefault = (list, kodKey, unvanKey, adiKey) => {
    if (list.length > 0) {
      return [list[0][kodKey], list[0][unvanKey], list[0][adiKey]];
    }
    return [0, null, null];
  };


  // Cari
  if (varmi.length === 1 && varmi[0].DefaultCariSirket != null) {
    defaultsirketler.DefaultCariSirket = varmi[0].DefaultCariSirket;
    defaultsirketler.DefaultCariSirketUnvan = this.getcariUnvan(musteriId, varmi[0].DefaultCariSirket, sirketler);
    defaultsirketler.DefaultCariSirketAdi = this.getcariSirketAdi(musteriId, varmi[0].DefaultCariSirket, sirketler);
  } else {
    [defaultsirketler.DefaultCariSirket, defaultsirketler.DefaultCariSirketUnvan, defaultsirketler.DefaultCariSirketAdi] = getFirstOrDefault(sirketler, 'SirketKodu', 'SirketUnvani', 'SirketAdi');
  }

  // Coper
  if (varmi.length === 1 && varmi[0].DefaultCoperSirket != null) {
     defaultsirketler.DefaultCoperSirket = varmi[0].DefaultCoperSirket;
    defaultsirketler.DefaultCoperSirketUnvan = this.getcoperUnvan(musteriId, varmi[0].DefaultCoperSirket, sirketlercoper);
    defaultsirketler.DefaultCoperSirketAdi = this.getcoperSirketAdi(musteriId, varmi[0].DefaultCoperSirket, sirketlercoper);
  } else {
    [defaultsirketler.DefaultCoperSirket, defaultsirketler.DefaultCoperSirketUnvan, defaultsirketler.DefaultCoperSirketAdi] = getFirstOrDefault(sirketlercoper, 'SirketNo', 'SirketIsmi', 'SirketKod');
  }

  // Muhasebe
  if (varmi.length === 1 && varmi[0].DefaultMuhasebeSirket != null) {
   
    defaultsirketler.DefaultMuhasebeSirketNo =this.getmuhasebeSirketNo(musteriId, varmi[0].DefaultMuhasebeSirket,
                    sirketlermuhasebe) ;
    defaultsirketler.DefaultMuhasebeSirketUnvan = this.getmuhasebeUnvan(musteriId, varmi[0].DefaultMuhasebeSirket, sirketlermuhasebe);
    defaultsirketler.DefaultMuhasebeSirketAdi = this.getmuhasebeSirketAdi(musteriId, varmi[0].DefaultMuhasebeSirket, sirketlermuhasebe);
  } else {
    [defaultsirketler.DefaultMuhasebeSirketNo, defaultsirketler.DefaultMuhasebeSirketUnvan, defaultsirketler.DefaultMuhasebeSirketAdi] = getFirstOrDefault(sirketlermuhasebe, 'CompanyID', 'CompanyLongName', 'CompanyShortName');
  }


  const response = JSON.parse(window.localStorage.getItem('response'));
  const credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

  if (sirketler.length === 0) {
    this.text1 = this.$t('No-sub-company-for-parent-company');
    this.snackbar = true;
    this.loadingdialog = false;
    auth.logout();
    return;
  }

  this.Sirket = {
    id: defaultsirketler.DefaultCariSirket,
    text: defaultsirketler.DefaultCariSirketAdi,
    unvan: defaultsirketler.DefaultCariSirketUnvan,
  };

  const credentials = {
    AnaSirketKodu: anasirketid,
    UlkeID: ulkeid,
    MusteriID: musteriId,
    ParaBirimi: parabirimi,
    UserID: userId,
    SirketKodu: this.Sirket.id,
    SirketAdi: this.Sirket.text,
    SirketUnvani: this.Sirket.unvan,
    Sirketler: sirketler,
    EArsiv: 1,
    EFatura: 1,
    CoperSirketNo: defaultsirketler.DefaultCoperSirket,
    CoperSirketAdi: defaultsirketler.DefaultCoperSirketAdi,
    CoperSirketUnvan: defaultsirketler.DefaultCoperSirketUnvan,
    CoperSirketler: sirketlercoper,
    MuhasebeSirketNo: defaultsirketler.DefaultMuhasebeSirketNo,
    MuhasebeSirketUnvan: defaultsirketler.DefaultMuhasebeSirketUnvan,
    MuhasebeSirketAdi: defaultsirketler.DefaultMuhasebeSirketAdi,
    MuhasebeSirketler: sirketlermuhasebe
  };

  if (credentials1 && credentials1.AnaSirketKodu === anasirketid) {
    Object.assign(credentials, credentials1);
  }

  window.localStorage.setItem('credentials', JSON.stringify(credentials));

  const credential = {
    Email: response.Email,
    Password: this.pass,
    ActiveMusteriKod: anasirketid
  };

  const paramssozlesme = {
    SozlesmeTip: 0,
    UserID: credentials.UserID,
    UlkeID: ulkeid,
    DilKodu: helpers.getaktifdil(),
  };

  try {
    const sozlesmeResponse = await this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractInfo', paramssozlesme, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
      }
    });

    if (!sozlesmeResponse.body.SozlesmeExist) {
      await auth.logingiris(this, credential);
    } else {
      const sonuc = await this.$refs.sozlesmedialog.open(sozlesmeResponse.body, 1);
      if (!sonuc) {
        this.text1 = this.$t('You-have-contract-approve');
        this.snackbar = true;
        return;
      }
      await auth.logingiris(this, credential);
    }

    
    await this.CoperWebScriptCreate(credentials);

    await this.$http.post(auth.API_URL + 'api/Register/WebScriptCreate', { MusteriID: credentials.MusteriID }, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
      }
    });
   await Yonlendir();
  } catch (err) {
    console.error('Hata:', err);
    this.text1 = 'Service Unavailable-WebScriptCreate';
    this.snackbar = true;
  }
}
async function Yonlendir()
{
     router.push({ path: '/' });
}
    function sysLogin_yeni(userId, musteriId, anasirketid, sirketler, ulkeid, parabirimi, sirketlercoper,sirketlermuhasebe,uyelikBitis,urunDetayi) {
        this.loadingmesaj = "Giriş ve ayar"
        this.loadingdialog = true

        var wuml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

         window.localStorage.setItem('uyelikBitisi',uyelikBitis);
         const parsed=JSON.stringify(urunDetayi);
         window.localStorage.setItem('kontorBilgileri',parsed);

        var varmi = wuml.UserInfo.DefaultSirketList.filter(function (el) {
            return el.MusteriID == musteriId
        });

        var defaultsirketler = {
            DefaultCariSirket: null,
            DefaultCariSirketUnvan: null,
            DefaultCariSirketAdi: null,
            DefaultCoperSirket: null,
            DefaultCoperSirketUnvan: null,
            DefaultCoperSirketAdi: null,
            DefaultMuhasebeSirketNo: null,
            DefaultMuhasebeSirketUnvan: null,
            DefaultMuhasebeSirketAdi: null,
        }

        //cari default sirket tespit
        if (varmi.length == 1) {
            if (varmi[0].DefaultCariSirket != null) {
                defaultsirketler.DefaultCariSirket = varmi[0].DefaultCariSirket
                defaultsirketler.DefaultCariSirketUnvan = this.getcariUnvan(musteriId, varmi[0].DefaultCariSirket,
                    sirketler)
                defaultsirketler.DefaultCariSirketAdi = this.getcariSirketAdi(musteriId, varmi[0].DefaultCariSirket,
                    sirketler)


            } else {

                if (sirketler.length != 0) {
                    defaultsirketler.DefaultCariSirket = sirketler[0].SirketKodu
                    defaultsirketler.DefaultCariSirketUnvan = sirketler[0].SirketUnvani
                    defaultsirketler.DefaultCariSirketAdi = sirketler[0].SirketAdi
                } else {
                    defaultsirketler.DefaultCariSirket = 0
                    defaultsirketler.DefaultCariSirketUnvan = null
                    defaultsirketler.DefaultCariSirketAdi = null
                }

            }
        } else {

            if (sirketler.length != 0) {
                defaultsirketler.DefaultCariSirket = sirketler[0].SirketKodu
                defaultsirketler.DefaultCariSirketUnvan = sirketler[0].SirketUnvani
                defaultsirketler.DefaultCariSirketAdi = sirketler[0].SirketAdi
            } else {
                defaultsirketler.DefaultCariSirket = 0
                defaultsirketler.DefaultCariSirketUnvan = null
                defaultsirketler.DefaultCariSirketAdi = null
            }
        }




        //coper default sirket tespit
        if (varmi.length == 1) {
            if (varmi[0].DefaultCoperSirket != null) {
            
                defaultsirketler.DefaultCoperSirket = varmi[0].DefaultCoperSirket
                defaultsirketler.DefaultCoperSirketUnvan = this.getcoperUnvan(musteriId, varmi[0].DefaultCoperSirket,
                    sirketlercoper)
                defaultsirketler.DefaultCoperSirketAdi = this.getcoperSirketAdi(musteriId, varmi[0].DefaultCoperSirket,
                    sirketlercoper)


            } else {

                if (sirketlercoper.length != 0) {
                    defaultsirketler.DefaultCoperSirket = sirketlercoper[0].SirketNo
                    defaultsirketler.DefaultCoperSirketUnvan = sirketlercoper[0].SirketIsmi
                    defaultsirketler.DefaultCoperSirketAdi = sirketlercoper[0].SirketKod
                } else {
                    defaultsirketler.DefaultCoperSirket = 0
                    defaultsirketler.DefaultCoperSirketUnvan = null
                    defaultsirketler.DefaultCoperSirketAdi = null
                }
            }
        } else {

            if (sirketlercoper.length != 0) {
                defaultsirketler.DefaultCoperSirket = sirketlercoper[0].SirketNo
                defaultsirketler.DefaultCoperSirketUnvan = sirketlercoper[0].SirketIsmi
                defaultsirketler.DefaultCoperSirketAdi = sirketlercoper[0].SirketKod
            } else {
                defaultsirketler.DefaultCoperSirket = 0
                defaultsirketler.DefaultCoperSirketUnvan = null
                defaultsirketler.DefaultCoperSirketAdi = null
            }
        }
        
        //muhasebe default sirket tespit
         if (varmi.length == 1) {
            if (varmi[0].DefaultMuhasebeSirketNo != null) {
                defaultsirketler.DefaultMuhasebeSirketNo =this.getmuhasebeSirketNo(musteriId, varmi[0].DefaultMuhasebeSirketNo,
                    sirketlermuhasebe) 
                defaultsirketler.DefaultMuhasebeSirketUnvan = this.getmuhasebeUnvan(musteriId, varmi[0].DefaultMuhasebeSirket,
                    sirketlermuhasebe)
                defaultsirketler.DefaultMuhasebeSirketAdi = this.getmuhasebeSirketAdi(musteriId, varmi[0].DefaultMuhasebeSirket,
                    sirketlermuhasebe)

            } else {
                if (sirketlermuhasebe.length != 0) {
                    defaultsirketler.DefaultMuhasebeSirketNo = sirketlermuhasebe[0].CompanyID
                    defaultsirketler.DefaultMuhasebeSirketUnvan = sirketlermuhasebe[0].CompanyShortName
                    defaultsirketler.DefaultMuhasebeSirketAdi = sirketlermuhasebe[0].CompanyLongName
                } else {
                    defaultsirketler.DefaultMuhasebeSirketNo = 0
                    defaultsirketler.DefaultMuhasebeSirketUnvan = null
                    defaultsirketler.DefaultMuhasebeSirketAdi = null
                }
            }
        } else {
            if (sirketlermuhasebe.length != 0) {
                defaultsirketler.DefaultMuhasebeSirketNo = sirketlermuhasebe[0].CompanyID
                defaultsirketler.DefaultMuhasebeSirketUnvan = sirketlermuhasebe[0].CompanyShortName
                defaultsirketler.DefaultMuhasebeSirketAdi = sirketlermuhasebe[0].CompanyLongName
            } else {
                defaultsirketler.DefaultMuhasebeSirketNo = 0
                defaultsirketler.DefaultMuhasebeSirketUnvan = null
                defaultsirketler.DefaultMuhasebeSirketAdi = null
            }
        }

        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

        if (sirketler.length > 0) {

            var response = JSON.parse(window.localStorage.getItem('response'));

            var earsiv = 0
            var efatura = 0

            this.Sirket.id = defaultsirketler.DefaultCariSirket
            this.Sirket.text = defaultsirketler.DefaultCariSirketAdi
            this.Sirket.unvan = defaultsirketler.DefaultCariSirketUnvan

            var credentials = {
                AnaSirketKodu: anasirketid,
                UlkeID: ulkeid,
                MusteriID: musteriId,
                ParaBirimi: parabirimi,
                UserID: userId,
                SirketKodu: this.Sirket.id,
                SirketAdi: this.Sirket.text,
                SirketUnvani: this.Sirket.unvan,
                Sirketler: sirketler,
                EArsiv: earsiv,
                EFatura: efatura,
                CoperSirketNo: defaultsirketler.DefaultCoperSirket,
                CoperSirketAdi: defaultsirketler.DefaultCoperSirketAdi,
                CoperSirketUnvan: defaultsirketler.DefaultCoperSirketUnvan,
                CoperSirketler: sirketlercoper,
                MuhasebeSirketNo: defaultsirketler.DefaultMuhasebeSirketNo,
                MuhasebeSirketUnvan: defaultsirketler.DefaultMuhasebeSirketUnvan,
                MuhasebeSirketAdi: defaultsirketler.DefaultMuhasebeSirketAdi,
                MuhasebeSirketler: sirketlermuhasebe
            }

            if (credentials1 != null && credentials1.AnaSirketKodu == anasirketid) {

                credentials.CoperSirketAdi = credentials1.CoperSirketAdi
                credentials.CoperSirketNo = credentials1.CoperSirketNo
                credentials.CoperSirketUnvan = credentials1.CoperSirketUnvan
                credentials.CoperSirketler = credentials1.CoperSirketler

                credentials.SirketKodu = credentials1.SirketKodu
                credentials.SirketAdi = credentials1.SirketAdi
                credentials.SirketUnvani = credentials1.SirketUnvani
                credentials.Sirketler = credentials1.Sirketler

                credentials.MuhasebeSirketNo = credentials1.MuhasebeSirketNo
                credentials.MuhasebeSirketAdi = credentials1.MuhasebeSirketAdi
                credentials.MuhasebeSirketUnvani = credentials1.MuhasebeSirketUnvani
                credentials.MuhasebeSirketler = credentials1.MuhasebeSirketler
            }



            window.localStorage.setItem('credentials', JSON.stringify(credentials));

            var params = {
                MusteriID: credentials.MusteriID
            }

            var response = JSON.parse(window.localStorage.getItem('response'));

            var credential = {
                Email: response.Email,
                Password: this.pass,
                ActiveMusteriKod: anasirketid
            }

            // kullancının onaylaması gereken bir sözleşme varmı
            var paramssozlesme = {
                SozlesmeTip: 0,
                UserID: credentials.UserID,
                UlkeID: ulkeid,
                DilKodu: helpers.getaktifdil(),

            }

            this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractInfo', paramssozlesme, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader(),
                    'CariSirketNo': credentials.SirketKodu.toString(),
                    'CoperSirketNo': credentials.CoperSirketNo.toString(),
                    'MusteriKodu': credentials.AnaSirketKodu.toString()
                }
            }).then((response) => {
                //    this.loadingdialog = false

                if (response.body.SozlesmeExist == false) {
                    auth.logingiris_yeni(this, credential).then(function()
        {
            this.CoperWebScriptCreate(credentials);
            this.$http.post(auth.API_URL + 'api/Register/WebScriptCreate', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
    }
}).then((response) => {

}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    } else {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    }
})

        }
        )
                } else {
                    this.$refs.sozlesmedialog.open(response.body, 1).then(sonuc => {
                        if (sonuc == true) {
                            auth.logingiris_yeni(this, credential).then(function()
        {
            this.CoperWebScriptCreate(credentials);
            this.$http.post(auth.API_URL + 'api/Register/WebScriptCreate', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
    }
}).then((response) => {
    auth.logingiris_yeni(this, credential).then(function()
        {
            this.CoperWebScriptCreate(credentials);
            this.$http.post(auth.API_URL + 'api/Register/WebScriptCreate', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
    }
}).then((response) => {

}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    } else {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    }
})

        }
        )
}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    } else {
        this.text1 = 'Service Unavailable-WebScriptCreate'
        this.snackbar = true
    }
})

        }
        )
                        } else {
                            this.text1 = this.$t('You-have-contract-approve')
                            this.snackbar = true
                        }
                    });
                }

            }, (response) => {
                  
                // this.loadingdialog = false
            })

        } else {
            this.text1 = this.$t('No-sub-company-for-parent-company')
            this.snackbar = true
            this.loadingdialog = false
            auth.logout()
        }



    }
    function girisDeneme(credential)
    {
       
    }
</script>
<style>

</style>